import * as React from "react"
import * as PpiDomain from "../../../../domain/sfp/ppi-domain"
import * as Model from "../../../../model"
export default class PpiFormPart extends React.Component<Props, State> {
	/** Option à afficher lorsque aucun thème n'est disponible. */
	private noThemeOption: React.ReactNode = <option
	title="Aucun projet disponible"
	disabled>
		Aucun projet disponible
	</option>
	/** Tableau des thèmes triés dans l'ordre alphabétique. */
	private sortedThemes: Model.PpiInvestmentTheme[] = []

	constructor(props: Readonly<Props>) {
		super(props)
		this.updateSortedThemes(props)
	}

	componentWillReceiveProps(nextProps: Readonly<Props>) {
		this.updateSortedThemes(nextProps)
	}

	render() {
		const ppiYears = this.props.ppi
		? this.props.ppi.years
		.filter(ppiYear => ppiYear.year >= new Date().getFullYear() - 1)
		: []

		return <section className="section">
			<h2>Plan pluriannuel d'investissement</h2>

			{!this.props.scenario
			? <p>Aucun scénario n'a été validé pour l'année en cours.</p>
			: !this.props.ppi
			? <p>Aucun PPI n'a été créé.</p>
			: [
				<div className="columns" key={0}>
					<div className="column is-full field is-grouped">
						{ppiYears.map((ppiYear, i) =>
						<div className="control" key={i}>
							<label className="checkbox">
								<input
								defaultChecked
								name={Names.Years}
								type="checkbox"
								value={ppiYear.year}/> {ppiYear.year}
							</label>
						</div>
						)}
					</div>
				</div>,
				<div className="columns is-multiline" key={1}>

					{/* PPI général */}
					<section className="column is-full section">

						<h3>PPI général</h3>

						<div className="field">
							<label className="checkbox">
								<input
								name={Names.InvestmentGeneralPpi.Tables}
								type="checkbox" />&nbsp;
								Inclure le tableau du PPI général
							</label>
						</div>
						<div className="columns">
							<div className="column is-full field is-grouped">
								<div className="prio-chooser">
									{[1, 2, 3, 4].map((p, i) => this.renderPriorityChecker(p, i))}
								</div>
							</div>
						</div>
					</section>
					{/* Fin PPI général */}

					{/* Dépenses */}
					<section className="column is-full is-half-widescreen section">
						<h3>Dépenses</h3>

						<p>Inclure les tableaux des dépenses des thèmes</p>

						<div className="field">
							<div className="select is-multiple is-fullwidth">
								<select name={Names.InvestmentExpense.Tables} size={5} multiple>
									{this.renderThemesOptions()}
								</select>
							</div>
						</div>
					</section>
					{/* Fin Dépenses */}

					{/* Fiches projets */}
					<section className="column is-full is-half-widescreen section">
						<h3>Fiches projets</h3>

						<p>Inclure les tableaux des fiches projets</p>

						<div className="field">
							<div className="select is-multiple is-fullwidth">
								<select name={Names.InvestmentProjects.Tables} size={5} multiple>
										{this.renderProjectsOptions()}
								</select>
							</div>
						</div>
					</section>
					{/* Fin Fiches projets */}
				</div>
			]}
		</section>
	}

	private renderProjectsOptions(): React.ReactNode {
		if (!this.sortedThemes.length) return this.noThemeOption

		return this.sortedThemes.map((theme, themeIndex) => {
			const options: React.ReactNodeArray = []
			let key = 0

			if (theme.themes && theme.themes.length) {
				theme.themes.forEach(subtheme => {
					if (!(subtheme.projects && subtheme.projects.length)) return

					subtheme.projects.forEach(project => {
						const label = `${subtheme.name} - ${project.name}`

						options.push(<option key={key++} title={label} value={project.id}>
							{label}
						</option>)
					})
				})
			} 
			if(theme.projects) {
				theme.projects.forEach(project => {
					options.push(
						<option key={key++} title={project.name} value={project.id}>
							{project.name}
						</option>)
				})
			}

			return <optgroup key={themeIndex} label={theme.name} title={theme.name}>
				{options}
			</optgroup>
		})
	}

	private renderPriorityChecker(priority: number, index: number): any {
		// const checked = !!this.props.selectedPriorities.some(p => priority === p)
		return <div className="control" key={index}>
			<label className="checkbox">
				<input
				defaultChecked
				name={Names.Priorities}
				type="checkbox"
				value={priority}/> Priorité {priority}
			</label>
		</div>
	}

	private renderThemesOptions(): React.ReactNode {
		if (!this.sortedThemes.length) return this.noThemeOption

		return this.sortedThemes.map((theme, themeIndex) => {
			if (theme.themes && theme.themes.length)
				return <optgroup key={themeIndex} label={theme.name} title={theme.name}>
					{theme.themes.map((subtheme, subthemeIndex) =>
					<option key={subthemeIndex} title={subtheme.name} value={subtheme.id}>
						{subtheme.name}
					</option>)}
				</optgroup>

			return <option key={themeIndex} title={theme.name} value={theme.id}>
				{theme.name}
			</option>
		})
	}

	private updateSortedThemes(props: Readonly<Props>): void {
		if (!props.ppi) return
		if (!props.ppi.investment_themes) return
		if (!props.ppi.investment_themes.length) return

		this.sortedThemes = PpiDomain.sortThemesByName(props.ppi.investment_themes)
	}
}

export const Names = {
	InvestmentExpense: {
		Tables: "ppi-expense-tables"
	},
	InvestmentGeneralPpi: {
		Tables: "ppi-general-tables"
	},
	InvestmentProjects: {
		Tables: "ppi-projects-tables"
	},
	Years: "ppi-years",
	Priorities: "priority"
}

export interface Props {
	ppi: Model.Ppi
	scenario: Model.Scenario
	services: Model.Service[]
}

interface State {}



// WEBPACK FOOTER //
// ./src/component/management-report/form-parts/ppi-form-part/index.tsx